// FassalkartAI - Public Route (redirect logged-in users away)

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

/**
 * Public-only route. If already authenticated, redirects to the
 * appropriate portal based on the user's role.
 */
const PublicRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) return <LoadingScreen />;

  if (currentUser) {
    const role = userProfile?.role;
    if (role === 'admin') return <Navigate to="/admin" replace />;
    if (role === 'company') return <Navigate to="/b2b/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
